// var Dev = false
import Vue from 'vue'
import App from './App'
import Resource from 'vue-resource'
import Router from 'vue-router'
import VueI18n from 'vue-i18n'
import VueMaterialComponents from 'vue-material-components'
import Moment from 'moment'
import Home from 'components/home/'
import Events from 'components/events/'
import Tournament from 'components/tournament/'
import VueCharts from 'vue-charts'

// import Multiplayer from 'components/multiplayer/'
// import CreateServer from 'components/createServer/'
import UserLoguin from 'components/user/loguin/'
import UserAccount from 'components/user/account/'
import UserData from 'components/user/account/data'
import Puzzle from 'components/puzzles/'
import Practice from 'components/practice/'
import Beginner from 'components/beginner/'
import Torneo from 'components/torneos/'
import Club from 'components/clubs/'
import '../static/pgnvjs/css/pgnvjs.min.css'
import '../static/css/materialize.min.css'
import 'vue-material-components/dist/vue-material-components.css'
import '../static/style.min.css'
import '../static/base.min.css'
import '../static/desktop.min.css'
import '../static/theme.min.css'
import '../static/css/google-icons/icon.css'
import '../static/css/myStyles.min.css'
import '../static/css/animate.min.css'
// Install plugins
import Storage from './services/lstorage'
import UserService from './services/user'
import VueSocketIO from 'vue-socket.io'
import SocketIO from 'socket.io-client'
import locale from './services/locales'

Vue.use(VueMaterialComponents)
Vue.use(Router)
Vue.use(Resource)
Vue.use(VueCharts)

// Configuration VueAnalytics
// Vue.forceUpdate()
console.log('Vue version:', Vue.version)
Vue.http.interceptors.push((request, next) => {
  // modify request
  var token = Storage.get('token')
  if (token) {
    request.headers['Authorization'] = 'Bearer ' + token
  }
  // continue to next interceptor
  next((response) => {
    // modify response
    if (response.status === 401 || response.status === 403) {
      const ctx = { $http: Vue.http }
      // desloguear user
      UserService.logout(ctx)
    }
  })
})
Storage.setPrefix('chessPlaza')
UserService.init()
// var dirServer = 'https://' + window.location.hostname + ':443' : window.location.origin
var dirServer = 'https://' + window.location.hostname
// console.log('DIRSERVER ' + dirServer)
// dirServer = Storage.set('serverDir', dirServer)
Storage.set('serverDir', dirServer)

Vue.http.options.root = Storage.get('serverDir')
// Vue.http.headers.common['Access-Control-Allow-Origin'] = '*'
// Vue.http.headers.common['Access-Control-Allow-Credentials'] = 'true'
// Vue.http.headers.common['Access-Control-Allow-Headers'] = 'Content-Type, Authorization, X-Requested-With'

Vue.filter('timeBoard', (s) => {
  var hours = parseInt(s / 3600)
  var minutes = parseInt((s % 3600) / 60)
  var seconds = s % 60
  return ('0' + hours).slice(-2) + ':' + ('0' + minutes).slice(-2) + ':' + ('0' + seconds).slice(-2)
})
/*
Vue.filter('timeBoard', (s) => {
  var min = parseInt(s / 60)
  // var min = s / 60
  var segs = s % 60
  return ('0' + min).slice(-2) + ':' + ('0' + segs).slice(-2)
})*/
Vue.filter('moment', (date, format) => {
  return Moment(date).format(format)
})
Vue.filter('reverse', (value) => {
  return value.slice().reverse()
})

if (Storage.get('token')) {
  const socket = SocketIO(Storage.get('serverDir'), {
    path: '/socket.io',
    transports: ['websocket'],
    allowEIO3: true,
    reconnection: true,
    reconnectionAttempts: Infinity,
    reconnectionDelay: 1000,
    reconnectionDelayMax: 5000,
    timeout: 20000,
    autoConnect: true,
    query: {
      token: 'Bearer ' + Storage.get('token')
    },
    rejectUnauthorized: false
  })

  const refreshAuthQuery = () => {
    if (socket && socket.io && socket.io.opts) {
      socket.io.opts.query = {
        token: 'Bearer ' + Storage.get('token')
      }
    }
  }

  socket.on('connect', () => {
    refreshAuthQuery()
    console.log('✅ Socket conectado desde Vue:', socket.id)
  })

  socket.on('disconnect', (reason) => {
    console.warn('⚠️ Socket desconectado. Motivo:', reason)
    if (reason === 'io server disconnect') {
      // El servidor forzó el cierre; tenemos que reconectar manualmente.
      socket.connect()
    }
  })

  socket.on('reconnect_attempt', (attempt) => {
    console.info('🔁 Reintentando conectar socket (intento %d)', attempt)
    refreshAuthQuery()
  })

  socket.on('reconnect', (attempt) => {
    console.log('✅ Socket reconectado después de %d intentos', attempt)
  })

  socket.on('reconnect_error', (err) => {
    console.error('❌ Error durante la reconexión del socket:', err.message)
  })

  if (socket.io && typeof socket.io.on === 'function') {
    socket.io.on('reconnect_failed', () => {
      console.error('❌ No se pudo reconectar al servidor de sockets, nuevo intento en breve')
    })
  }
  socket.on('connect_error', (err) => {
    console.error('❌ Error al conectar socket:', err.message)
  })

  Vue.use(VueSocketIO, socket)
}

// install plugin
Vue.use(VueI18n)
// ready translated locales
const lan = Storage.get('lenguaje', 'es')
const locales = locale.i18n
Vue.config.lang = lan
// set locales
Object.keys(locales).forEach((lang) => {
  Vue.locale(lang, locales[lang])
})
Vue.transition('entern', {
  enterClass: 'pulse',
  leaveClass: 'invisible'
})
// Set up a new router
var router = new Router()
// Route config
router.map({
  '/home': {
    name: 'home',
    component: Home
  },
  '/events': {
    name: 'events',
    component: Events
  },
  '/tournament': {
    name: 'tournament',
    component: Tournament
  },
  '/user': {
    name: 'user',
    component: {
      template: '<div class="row"><router-view></router-view></div>'
    },
    subRoutes: {
      '/:username': {
        component: UserAccount,
        name: 'user',
        subRoutes: {
          '/': {
            name: 'userdata',
            component: UserData
          },
          '/otheruser': {
            name: 'otheruser',
            component (resolve) {
              require(['./components/user/account/otheruser'], resolve)
            }
          },
          '/elo': {
            name: 'elo',
            component (resolve) {
              require(['./components/user/account/elo'], resolve)
            }
          },
          '/admin': {
            name: 'admin',
            component (resolve) {
              require(['./components/user/account/admin'], resolve)
            }
          },
          '/config': {
            name: 'config',
            component (resolve) {
              require(['./components/user/account/config'], resolve)
            }
          },
          '/activity': {
            name: 'activity',
            component (resolve) {
              require(['./components/user/account/activity'], resolve)
            }
          },
          '/registernew': {
            name: 'registernew',
            component (resolve) {
              require(['./components/user/register/'], resolve)
            }
          },
          '/edit': {
            name: 'edituser',
            component (resolve) {
              require(['./components/user/register/'], resolve)
            }
          }
        }
      },
      '/register': {
        name: 'register',
        component (resolve) {
          require(['./components/user/register/'], resolve)
        }
      },
      '/guest': {
        name: 'guest',
        component (resolve) {
          require(['./components/user/register/'], resolve)
        }
      },
      '/loguin': {
        name: 'loguin',
        component: UserLoguin
      }
    }
  },
  /*
  '/multiplayer': {
    name: 'multiplayer',
    component: Multiplayer
  },
  '/createServer': {
    name: 'createServer',
    component: CreateServer
  },
  */
  '/game/:idBoard': {
    name: 'game',
    component (resolve) {
      require(['./components/game/'], resolve)
    }
  },
  /* '/game2/:idBoard': {
    name: 'game',
    component (resolve) {
      require(['./components/game/'], resolve)
    }
  },*/
  '/visor/:idBoard/:skip/:u1/:u2': {
    name: 'visor',
    component (resolve) {
      require(['./components/boardVisor/'], resolve)
    }
  },
  '/lesson/:idBoard/:skip/:u1/:u2': {
    name: 'lesson',
    component (resolve) {
      require(['./components/boardLesson/'], resolve)
    }
  },
  '/puzzle': {
    name: 'puzzle',
    component: Puzzle
  },
  '/practice': {
    name: 'practice',
    component: Practice
  },
  '/beginner': {
    name: 'beginner',
    component: Beginner
  },
  '/torneo': {
    name: 'torneo',
    component: Torneo
  },
  '/club': {
    name: 'club',
    component: Club
  }
})
// For every new route scroll to the top of the page
router.beforeEach(function () {
  window.scrollTo(0, 0)
})
// If no route is matched redirect home
router.redirect({
  '*': '/home'
})
// Start up our app
router.start(App, '#app')



// WEBPACK FOOTER //
// ./src/main.js